import { useEffect } from 'react';
import { useAuthStore } from '../stores/authStore';
import api from '../lib/api';
import { applyTheme, readStoredTheme } from '../lib/theme';
import { applyAppearanceFromSettings, bootstrapAppearance } from '../lib/appearance';

export default function ThemeBridge() {
  const user = useAuthStore((s) => s.user);

  useEffect(() => {
    applyTheme(readStoredTheme());
    bootstrapAppearance();
  }, []);

  useEffect(() => {
    if (!user) return;
    (async () => {
      try {
        const { data } = await api.get('/users/me/settings');
        if (data?.darkMode === true) {
          applyTheme(true);
        } else if (data?.darkMode === false) {
          applyTheme(false);
        }
        applyAppearanceFromSettings(data as Record<string, unknown>);
      } catch {
        /* ignore */
      }
    })();
  }, [user?.id]);

  return null;
}
